import { AmpElement } from "./AmpElement"
import { AmpTemplate } from "./AmpTemplate"

export const Amp3dGltf = () => {
  return <AmpElement name="amp-3d-gltf" version="0.1" />
}

export const Amp3qPlayer = () => {
  return <AmpElement name="amp-3q-player" version="0.1" />
}

export const AmpAccessLaterpay = () => {
  return <AmpElement name="amp-access-laterpay" version="0.2" />
}

export const AmpAccessPoool = () => {
  return <AmpElement name="amp-access-poool" version="0.1" />
}

export const AmpAccessScroll = () => {
  return <AmpElement name="amp-access-scroll" version="0.1" />
}

export const AmpAccess = () => {
  return <AmpElement name="amp-access" version="0.1" />
}

export const AmpAccordion = () => {
  return <AmpElement name="amp-accordion" version="0.1" />
}

export const AmpActionMacro = () => {
  return <AmpElement name="amp-action-macro" version="0.1" />
}

export const AmpAdCustom = () => {
  return <AmpElement name="amp-ad-custom" version="0.1" />
}

export const AmpAd = () => {
  return <AmpElement name="amp-ad" version="0.1" />
}

export const AmpAddthis = () => {
  return <AmpElement name="amp-addthis" version="0.1" />
}

export const AmpAnalytics = () => {
  return <AmpElement name="amp-analytics" version="0.1" />
}

export const AmpAnim = () => {
  return <AmpElement name="amp-anim" version="0.1" />
}

export const AmpAnimation = () => {
  return <AmpElement name="amp-animation" version="0.1" />
}

export const AmpApesterMedia = () => {
  return <AmpElement name="amp-apester-media" version="0.1" />
}

export const AmpAppBanner = () => {
  return <AmpElement name="amp-app-banner" version="0.1" />
}

export const AmpAudio = () => {
  return <AmpElement name="amp-audio" version="0.1" />
}

export const AmpAutoAds = () => {
  return <AmpElement name="amp-auto-ads" version="0.1" />
}

export const AmpAutocomplete = () => {
  return <AmpElement name="amp-autocomplete" version="0.1" />
}

export const AmpBaseCarousel = () => {
  return <AmpElement name="amp-base-carousel" version="0.1" />
}

export const AmpBeopinion = () => {
  return <AmpElement name="amp-beopinion" version="0.1" />
}

export const AmpBind = () => {
  return <AmpElement name="amp-bind" version="0.1" />
}

export const AmpBodymovinAnimation = () => {
  return <AmpElement name="amp-bodymovin-animation" version="0.1" />
}

export const AmpBridPlayer = () => {
  return <AmpElement name="amp-brid-player" version="0.1" />
}

export const AmpBrightcove = () => {
  return <AmpElement name="amp-brightcove" version="0.1" />
}

export const AmpBysideContent = () => {
  return <AmpElement name="amp-byside-content" version="0.1" />
}

export const AmpCallTracking = () => {
  return <AmpElement name="amp-call-tracking" version="0.1" />
}

export const AmpCarousel = () => {
  return <AmpElement name="amp-carousel" version="0.2" />
}

export const AmpConnatixPlayer = () => {
  return <AmpElement name="amp-connatix-player" version="0.1" />
}

export const AmpConsent = () => {
  return <AmpElement name="amp-consent" version="0.1" />
}

export const AmpDailymotion = () => {
  return <AmpElement name="amp-dailymotion" version="0.1" />
}

export const AmpDateCountdown = () => {
  return <AmpElement name="amp-date-countdown" version="0.1" />
}

export const AmpDateDisplay = () => {
  return <AmpElement name="amp-date-display" version="0.1" />
}

export const AmpDatePicker = () => {
  return <AmpElement name="amp-date-picker" version="0.1" />
}

export const AmpDelightPlayer = () => {
  return <AmpElement name="amp-delight-player" version="0.1" />
}

export const AmpDynamicCssClasses = () => {
  return <AmpElement name="amp-dynamic-css-classes" version="0.1" />
}

export const AmpEmbedlyCard = () => {
  return <AmpElement name="amp-embedly-card" version="0.1" />
}

export const AmpExperiment = () => {
  return <AmpElement name="amp-experiment" version="1.0" />
}

export const AmpFacebookComments = () => {
  return <AmpElement name="amp-facebook-comments" version="0.1" />
}

export const AmpFacebookLike = () => {
  return <AmpElement name="amp-facebook-like" version="0.1" />
}

export const AmpFacebookPage = () => {
  return <AmpElement name="amp-facebook-page" version="0.1" />
}

export const AmpFacebook = () => {
  return <AmpElement name="amp-facebook" version="0.1" />
}

export const AmpFitText = () => {
  return <AmpElement name="amp-fit-text" version="0.1" />
}

export const AmpFont = () => {
  return <AmpElement name="amp-font" version="0.1" />
}

export const AmpForm = () => {
  return <AmpElement name="amp-form" version="0.1" />
}

export const AmpFxCollection = () => {
  return <AmpElement name="amp-fx-collection" version="0.1" />
}

export const AmpFxFlyingCarpet = () => {
  return <AmpElement name="amp-fx-flying-carpet" version="0.1" />
}

export const AmpGeo = () => {
  return <AmpElement name="amp-geo" version="0.1" />
}

export const AmpGfycat = () => {
  return <AmpElement name="amp-gfycat" version="0.1" />
}

export const AmpGist = () => {
  return <AmpElement name="amp-gist" version="0.1" />
}

export const AmpGoogleDocumentEmbed = () => {
  return <AmpElement name="amp-google-document-embed" version="0.1" />
}

export const AmpHulu = () => {
  return <AmpElement name="amp-hulu" version="0.1" />
}

export const AmpIframe = () => {
  return <AmpElement name="amp-iframe" version="0.1" />
}

export const AmpImaVideo = () => {
  return <AmpElement name="amp-ima-video" version="0.1" />
}

export const AmpImageLightbox = () => {
  return <AmpElement name="amp-image-lightbox" version="0.1" />
}

export const AmpImageSlider = () => {
  return <AmpElement name="amp-image-slider" version="0.1" />
}

export const AmpImgur = () => {
  return <AmpElement name="amp-imgur" version="0.1" />
}

export const AmpInputmask = () => {
  return <AmpElement name="amp-inputmask" version="0.1" />
}

export const AmpInstagram = () => {
  return <AmpElement name="amp-instagram" version="0.1" />
}

export const AmpInstallServiceworker = () => {
  return <AmpElement name="amp-install-serviceworker" version="0.1" />
}

export const AmpIzlesene = () => {
  return <AmpElement name="amp-izlesene" version="0.1" />
}

export const AmpJwplayer = () => {
  return <AmpElement name="amp-jwplayer" version="0.1" />
}

export const AmpKalturaPlayer = () => {
  return <AmpElement name="amp-kaltura-player" version="0.1" />
}

export const AmpLightboxGallery = () => {
  return <AmpElement name="amp-lightbox-gallery" version="0.1" />
}

export const AmpLightbox = () => {
  return <AmpElement name="amp-lightbox" version="0.1" />
}

export const AmpLinkRewriter = () => {
  return <AmpElement name="amp-link-rewriter" version="0.1" />
}

export const AmpList = () => {
  return (
    <>
      <AmpMustache />
      <AmpElement name="amp-list" version="0.1" />
    </>
  )
}

export const AmpLiveList = () => {
  return <AmpElement name="amp-live-list" version="0.1" />
}

export const AmpMathml = () => {
  return <AmpElement name="amp-mathml" version="0.1" />
}

export const AmpMegaphone = () => {
  return <AmpElement name="amp-megaphone" version="0.1" />
}

export const AmpMinuteMediaPlayer = () => {
  return <AmpElement name="amp-minute-media-player" version="0.1" />
}

export const AmpMowplayer = () => {
  return <AmpElement name="amp-mowplayer" version="0.1" />
}

export const AmpMustache = () => {
  return <AmpTemplate name="amp-mustache" version="0.2" />
}

export const AmpNextPage = () => {
  return <AmpElement name="amp-next-page" version="0.1" />
}

export const AmpNexxtvPlayer = () => {
  return <AmpElement name="amp-nexxtv-player" version="0.1" />
}

export const AmpO2Player = () => {
  return <AmpElement name="amp-o2-player" version="0.1" />
}

export const AmpOoyalaPlayer = () => {
  return <AmpElement name="amp-ooyala-player" version="0.1" />
}

export const AmpOrientationObserver = () => {
  return <AmpElement name="amp-orientation-observer" version="0.1" />
}

export const AmpPanZoom = () => {
  return <AmpElement name="amp-pan-zoom" version="0.1" />
}

export const AmpPinterest = () => {
  return <AmpElement name="amp-pinterest" version="0.1" />
}

export const AmpPlaybuzz = () => {
  return <AmpElement name="amp-playbuzz" version="0.1" />
}

export const AmpPositionObserver = () => {
  return <AmpElement name="amp-position-observer" version="0.1" />
}

export const AmpPowrPlayer = () => {
  return <AmpElement name="amp-powr-player" version="0.1" />
}

export const AmpReachPlayer = () => {
  return <AmpElement name="amp-reach-player" version="0.1" />
}

export const AmpRecaptchaInput = () => {
  return <AmpElement name="amp-recaptcha-input" version="0.1" />
}

export const AmpReddit = () => {
  return <AmpElement name="amp-reddit" version="0.1" />
}

export const AmpRiddleQuiz = () => {
  return <AmpElement name="amp-riddle-quiz" version="0.1" />
}

export const AmpSelector = () => {
  return <AmpElement name="amp-selector" version="0.1" />
}

export const AmpSidebar = () => {
  return <AmpElement name="amp-sidebar" version="0.1" />
}

export const AmpSkimlinks = () => {
  return <AmpElement name="amp-skimlinks" version="0.1" />
}

export const AmpSlides = () => {
  return <AmpElement name="amp-slides" version="0.1" />
}

export const AmpSmartlinks = () => {
  return <AmpElement name="amp-smartlinks" version="0.1" />
}

export const AmpSocialShare = () => {
  return <AmpElement name="amp-social-share" version="0.1" />
}

export const AmpSoundcloud = () => {
  return <AmpElement name="amp-soundcloud" version="0.1" />
}

export const AmpSpringboardPlayer = () => {
  return <AmpElement name="amp-springboard-player" version="0.1" />
}

export const AmpStickyAd = () => {
  return <AmpElement name="amp-sticky-ad" version="1.0" />
}

export const AmpStoryAutoAds = () => {
  return <AmpElement name="amp-story-auto-ads" version="0.1" />
}

export const AmpStory = () => {
  return <AmpElement name="amp-story" version="1.0" />
}

export const AmpSubscriptions = () => {
  return <AmpElement name="amp-subscriptions" version="0.1" />
}

export const AmpSubscriptionsGoogle = () => {
  return <AmpElement name="amp-subscriptions-google" version="0.1" />
}

export const AmpTimeago = () => {
  return <AmpElement name="amp-timeago" version="0.1" />
}

export const AmpTruncateText = () => {
  return <AmpElement name="amp-truncate-text" version="0.1" />
}

export const AmpTwitter = () => {
  return <AmpElement name="amp-twitter" version="0.1" />
}

export const AmpUserLocation = () => {
  return <AmpElement name="amp-user-location" version="0.1" />
}

export const AmpUserNotification = () => {
  return <AmpElement name="amp-user-notification" version="0.1" />
}

export const AmpVideoDocking = () => {
  return <AmpElement name="amp-video-docking" version="0.1" />
}

export const AmpVideoIframe = () => {
  return <AmpElement name="amp-video-iframe" version="0.1" />
}

export const AmpVideo = () => {
  return <AmpElement name="amp-video" version="0.1" />
}

export const AmpVimeo = () => {
  return <AmpElement name="amp-vimeo" version="0.1" />
}

export const AmpVine = () => {
  return <AmpElement name="amp-vine" version="0.1" />
}

export const AmpViqeoPlayer = () => {
  return <AmpElement name="amp-viqeo-player" version="0.1" />
}

export const AmpVk = () => {
  return <AmpElement name="amp-vk" version="0.1" />
}

export const AmpWebPush = () => {
  return <AmpElement name="amp-web-push" version="0.1" />
}

export const AmpWistiaPlayer = () => {
  return <AmpElement name="amp-wistia-player" version="0.1" />
}

export const AmpYotpo = () => {
  return <AmpElement name="amp-yotpo" version="0.1" />
}

export const AmpYoutube = () => {
  return <AmpElement name="amp-youtube" version="0.1" />
}
